import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";// Bootstrap CSS
import "bootstrap/dist/js/bootstrap.bundle.min";// Bootstrap Bundle JS

import './App.css';
import Home from './Components/Home/Home';
import Estimate from './Components/Estimate/Estimate';
import Error from './Components/Error/Error';

export default function App() {
  return (
    <div className="App">
      <header>
        <h2>Iowa State University</h2>
        <h3>Office of Student Financial Aid</h3>
      </header>

      <main>
        <Router basename='/expense'>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/estimator/*" element={<Estimate />} />
            <Route exact path="/error" element={<Error />} />
            <Route path="*" element={<Navigate to="/error" replace={true} />} />
          </Routes>
        </Router>
      </main>

      <footer className="footer">
        <div className="copy text-white">&copy; Office of Student Finacial Aid</div>
      </footer>
    </div>
  )
}
